import React, { useRef } from "react";
import { Box, CardMedia, Typography } from "@mui/material";
import * as Reorder from "../../../components/dnd/Reorder";
import { DraggerIcon } from "../../../utils/icons";
import placeholder from "../../../assets/video_placeholder.png";
import { formatVideoName } from "../videos/hooks/useFetchVideos";
import { fancyTimeFormat } from "../videos/adminVideosV2/helper";

interface Props {
    video: any;
    index: number;
}

const thumbnailFor = (video: any) => {
    const url = video?.location || video?.reviewS3File?.location || "";
    if (!url) return placeholder;
    return url.includes(".mp4") ? url.replace(".mp4", "_thumbnail.png") : url;
};

/** Compact draggable row shown while reordering a video shortlist. */
export function ReorderVideoRow({ video, index }: Props) {
    const containerRef = useRef<HTMLDivElement>(null);

    const metadata = [
        video?.version ? `Version ${video.version}` : null,
        video?.aspect_ratio || null,
        video?.length ? fancyTimeFormat(video.length) : null,
        video?.videoProducts?.[0]?.title || null,
    ].filter(Boolean);

    return (
        <div
            ref={containerRef}
            className="flex items-center gap-4 p-4 w-full bg-surface"
            style={{ borderRadius: "16px", border: "1px solid var(--border)" }}
        >
            <Reorder.Trigger index={index} containerRef={containerRef}>
                <Box className="flex items-center justify-center cursor-grab p-1">
                    {/* stroke lands on an SVG presentation attribute — cannot take var(); left literal */}
                    <DraggerIcon size={26} stroke="#C6C6C6" />
                </Box>
            </Reorder.Trigger>

            <CardMedia
                component="img"
                style={{ width: 95, height: 55, objectFit: "cover" }}
                image={thumbnailFor(video)}
                alt=""
                className="rounded-lg flex-shrink-0"
            />

            <Box className="flex flex-col min-w-0">
                <Typography
                    sx={{
                        fontWeight: 900,
                        fontSize: "16px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}
                >
                    {formatVideoName(video?.title || video?.name || video?.key || "")}
                </Typography>
                {metadata.length > 0 && (
                    <Typography sx={{ fontSize: "14px", color: "var(--text-2)" }}>
                        {metadata.join(" | ")}
                    </Typography>
                )}
            </Box>
        </div>
    );
}
